import { lsGetAuthToken } from 'helpers/store';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  token: lsGetAuthToken(),
  status: '',
  hasLoadedOnce: false
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
